import React, { useContext } from 'react';
import { useAuth } from '@src/firebase/useAuth';
import { doLoginToBackend } from '../../api/index';
import toast from 'react-hot-toast';
import '@szhsin/react-menu/dist/index.css';
import CrioButton from '@components/v5/CrioButton/index';
import { GlobalStateContext } from '@src/context/GlobalContextProvider';
import { GTM } from '../../analytics/gtm';
import { gtmEvents } from '../../analytics/gtmEventsConstant';
import { ELeadSquaredActivityCode } from '@src/constants/leadsquaredActivityConstants/index';
import useSendActivities from '@src/hooks/useSendActivities';

const SignInButton = ({ className }) => {
  const state = useContext(GlobalStateContext);
  const { sendActivityHandler } = useSendActivities();

  const auth = useAuth();

  const handlePostFirebaseLogin = async (idToken, cb) => {
    let response = await doLoginToBackend(idToken);

    if (response) {
      cb();
    } else {
      toast.error(
        'Authentication failed due to poor network connection. Please refresh your browser and try again.',
        { duration: 8000, style: { fontSize: '14px' }, id: 'auth' },
      );
    }
  };

  async function handleLogin(e) {
    GTM.track(gtmEvents.USER_SIGNIN);
    sendActivityHandler(ELeadSquaredActivityCode.SIGN_IN_CLICKED);
    e.preventDefault();
    window.open('/learn/login', '_self');
  }

  return (
    <div>
      <CrioButton
        variant="secondary"
        className={`h-[38px] ${className}`}
        onClick={handleLogin}
      >
        {'Sign In'}
      </CrioButton>
    </div>
  );
};

export default SignInButton;
